<div class="modal-header">
  <div class="modal-header-x" (click)="bsModalRef.hide()">
    <i-feather name="x"></i-feather>
  </div>
</div>
<quote-reposts-details [postHashHex]="postHashHex" [bsModalRef]="bsModalRef"></quote-reposts-details>
